import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { inputCls, btn, Card, H, errMsg } from "./shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ah = () => ({ withCredentials: true });

export const Profile = ({ user, refreshUser, l }) => {
  const [f, setF] = useState({ name: "", phone: "", line1: "", line2: "", postal_code: "", city: "", country: "CH" });
  const [em, setEm] = useState({ new_email: "", password: "", code: "", step: 0 });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (user) setF((x) => ({ ...x, name: user.name || "", phone: user.phone || "", ...(user.address || {}) })); }, [user]);

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { name, phone, ...address } = f;
      await axios.put(`${API}/auth/profile`, { name, phone, address }, ah()); toast.success(l.saved); refreshUser();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const requestEmail = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await axios.post(`${API}/account/email/request`, { new_email: em.new_email, password: em.password }, ah()); toast.success(l.codeSent); setEm({ ...em, step: 1 }); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const confirmEmail = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await axios.post(`${API}/account/email/confirm`, { code: em.code }, ah()); toast.success(l.emailChanged); setEm({ new_email: "", password: "", code: "", step: 0 }); refreshUser(); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  const I = (k, ph, extra = {}) => <input data-testid={`profile-${k}`} className={inputCls} placeholder={ph} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} {...extra} />;

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <Card data-testid="account-profile">
        <H>{l.title}</H>
        <form onSubmit={save} className="space-y-3">
          {I("name", l.name, { required: true, minLength: 2 })}
          {I("phone", l.phone)}
          {I("line1", l.line1)}
          {I("line2", l.line2)}
          <div className="grid grid-cols-[110px_1fr_90px] gap-3">
            {I("postal_code", l.zip)}{I("city", l.city)}
            <select data-testid="profile-country" className={inputCls} value={f.country || "CH"} onChange={(e) => setF({ ...f, country: e.target.value })}><option value="CH">CH</option><option value="LI">LI</option></select>
          </div>
          <button data-testid="profile-save" disabled={busy} className={btn}>{l.save}</button>
        </form>
      </Card>
      <Card data-testid="account-email-change">
        <H>{l.emailTitle}</H>
        <p className="text-sm text-stone-600 mb-4 font-mono">{user.email}</p>
        {em.step === 0 ? (
          <form onSubmit={requestEmail} className="space-y-3">
            <input data-testid="email-new" required type="email" className={inputCls} placeholder={l.newEmail} value={em.new_email} onChange={(e) => setEm({ ...em, new_email: e.target.value })} />
            <input data-testid="email-password" required type="password" className={inputCls} placeholder={l.pw} value={em.password} onChange={(e) => setEm({ ...em, password: e.target.value })} />
            <button data-testid="email-send-code" disabled={busy} className={btn}>{l.sendCode}</button>
          </form>
        ) : (
          <form onSubmit={confirmEmail} className="space-y-3">
            <input data-testid="email-code" required maxLength={6} className={`${inputCls} font-mono tracking-[0.4em]`} placeholder={l.code} value={em.code} onChange={(e) => setEm({ ...em, code: e.target.value.replace(/\D/g, "") })} />
            <button data-testid="email-confirm" disabled={busy || em.code.length !== 6} className={btn}>{l.confirm}</button>
          </form>
        )}
      </Card>
    </div>
  );
};
